import { useCallback, useState } from 'react';
import { RewindCamPlayerHandle } from '../RewindCamPlayer';

export const rewindTimeoutDuration = 10 * 60 * 1000;

const useCamRewindTimeout = (rewindCamPlayerHandle: React.RefObject<RewindCamPlayerHandle>) => {
  const [, setTimeoutObj] = useState<NodeJS.Timeout | undefined>(undefined);

  const resetTimeout = useCallback(() => {
    setTimeoutObj((currTimeout) => {
      if (currTimeout) clearTimeout(currTimeout);
      return setTimeout(() => {
        rewindCamPlayerHandle.current?.pause();
      }, rewindTimeoutDuration);
    });
  }, [rewindCamPlayerHandle]);

  return { resetTimeout };
};

export default useCamRewindTimeout;
